export default __webpack_public_path__ + "static/media/logo_small.dff0176b.svg";